// extracted by mini-css-extract-plugin
export var assigneeBadge = "_nf-0";
export var assigneeDetails = "_nf-1";
export var assigneeInfo = "_nf-2";
export var dropdownContainer = "_nf-4";
export var dropdownImage = "_nf-5";
export var editAssigneeInfo = "_nf-3";
export var editAssigneeModalContainer = "_nf-6";
export var hidden = "_nf-8";
export var input = "_nf-7";